module.exports = __webpack_public_path__ + "static/media/jobs.334ae795.svg";